module.exports = __webpack_public_path__ + "images/54cde55f84620b559f4e4da97e3e9c81.png";